export const NavBtn = ({ href, children }) => {

  const pathname = window.location.pathname;

  const style = pathname == "/"+href || pathname == href ? {color: "cyan"} : {};

  return <div className="navItem">
    <a href={href} style={style}>{children}</a>
  </div>
}